import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

import CardArrow from "@areas/shared/components/cards/CardArrow";
import Pagination from "@areas/shared/components/paginations/Pagination";

import styles from "../blocks/styles/addition.module.css";
import paginationStyles from "@areas/employer/components/pagination/styles/pagination.module.css";

function formatSalary(value) {
  if (value == null || value === "") {
    return "";
  }
  return `${Math.round(value).toLocaleString("ru-RU")} ₽`;
}

function formatSalaryRange(salaryMin, salaryMax) {
  const min = formatSalary(salaryMin);
  const max = formatSalary(salaryMax);

  if (min && max) {
    return `${min} — ${max}`;
  }

  return min || max || "";
}

function SpecialistsTab({ load, results, limit, onChangePage }) {
  return (
    <>
      {load ? (
        <div className="d-flex justify-content-center w-100">
          <ClipLoader />
        </div>
      ) : results.data.length > 0 ? (
        <div className={styles.tabContent}>
          <div className={styles.practices}>
            {results.data.map((item) => {
              const salary = formatSalaryRange(item.SalaryMin, item.SalaryMax);

              return (
                <CardArrow
                  key={item.Id}
                  sizeArrow={{ width: 17, height: 17 }}
                  customStyles={{
                    main: styles.card,
                    border: styles.border,
                    arrow: styles.arrow,
                  }}
                  rotate="leftTop"
                >
                  <div className={styles.inner}>
                    <div className={styles.title}>{item.Specialist}</div>
                    {item.Industry ? (
                      <div className={styles.subtitle}>{item.Industry}</div>
                    ) : null}
                    {salary ? (
                      <div className={styles.description}>Зарплата: {salary}</div>
                    ) : null}
                  </div>
                </CardArrow>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center w-100">
          Ничего не найдено
        </div>
      )}
      <Pagination
        load={load}
        itemsPerPage={limit}
        totalItems={results.total}
        onChangePage={onChangePage}
        customStyles={{
          prev: paginationStyles.prev,
          current: paginationStyles.current,
          next: paginationStyles.next,
        }}
      />
    </>
  );
}

export default SpecialistsTab;
